<template>
    <div class="Firmware-version">
      <pageTitle v-bind="{ ...pT }" />
      <business-group
        ref="businessGroup"
        :tableConfig="{ ...tableConfig }"
        :formConfig="{ ...formConfig }"
      >
        <template slot="formSlot" slot-scope="formSlot">
          <a-form-item>
            <a-input
              placeholder="请输入灯光名"
              v-decorator="['title']"
              style="width: 520px; margin-right: 10px; vertical-align: middle"
            />
          </a-form-item>
          <a-form-item>
            <a-select placeholder="请选择语言" show-search :options="langs" optionFilterProp="children" v-decorator="['lang']" style="width: 150px">
            </a-select>
          </a-form-item>
        </template>
        <template slot="formRight">
          <a-button type="primary" @click="add">新增</a-button>
        </template>
        <template  slot="pic" slot-scope="record">
          <img width="100" :src="record.pic" />
        </template>
        <template  slot="lang" slot-scope="record">
          {{ getLangShow(record.lang) }}
        </template>
        <template slot="action" slot-scope="record">
          <a-button type="link" @click="edit(record)">编辑</a-button>
          <a-button type="link" @click="del(record)">删除</a-button>
          <a-button type="link" @click="view(record.id)">添加操作步骤</a-button>
        </template>
      </business-group>
      <a-drawer
        :visible="visible"
        :title="title"
        destroyOnClose
        @ok="submitForm('ruleForm')"
        @close="resetForm('ruleForm')"
        :maskClosable="false"
        width="1200px"
      >
        <a-form-model
          ref="ruleForm"
          class="Firmware-version_ruleForm"
          :model="ruleForm"
          :rules="rules"
        >
          <a-form-model-item label="灯光名" prop="title">
            <a-textarea   placeholder="请输入灯光名称" v-model="ruleForm.title"   :maxlength="64" />
          </a-form-model-item>
          <a-form-model-item label="灯光类型" prop="lightType">
            <a-textarea   placeholder="请输入灯光类型" v-model="ruleForm.lightType"   :maxlength="64" />
          </a-form-model-item>
          <a-form-model-item label="色温范围" prop="temperature">
            <a-input-number v-model="ruleForm.temperatureMin" /> K ~ <a-input-number  v-model="ruleForm.temperatureMax" /> K
          </a-form-model-item>
          <a-form-model-item label="供电方式" prop="powerSupplyMode">
            <a-input placeholder="供电方式" v-model="ruleForm.powerSupplyMode"   :maxlength="64" />
          </a-form-model-item>
          <a-form-model-item label="连接方式" prop="connectionMode">
            <a-input placeholder="连接方式" v-model="ruleForm.connectionMode"   :maxlength="64" />
          </a-form-model-item>
          <a-form-model-item label="购买链接" prop="purchaseLink">
            <a-input placeholder="购买链接" v-model="ruleForm.purchaseLink"   />
          </a-form-model-item>
          <a-form-model-item label="图片" prop="pic">
            <a-upload
            name="pic"
            :before-upload="beforeUpload"
            v-model="ruleForm.pic"
            :remove="remove"
            :file-list="files"
            class="m-upload"
            :disabled="!nowTitleIsNew"
            >
              <a-icon v-if="files.length <= 0" :type="upLoading ? 'loading' : 'plus'" />
            </a-upload>
          </a-form-model-item>
          <a-form-model-item label="语言" prop="lang">
            <a-select placeholder="请选择语言" v-model="ruleForm.lang" show-search :options="langs" optionFilterProp="children" v-decorator="['lang']" style="width: 150px"></a-select>
          </a-form-model-item>
          <a-form-model-item label="排序字段" prop="idx">
            <a-input-number placeholder="排序字段" v-model="ruleForm.idx" />
          </a-form-model-item>

        </a-form-model>
        <div
          :style="{
            position: 'absolute',
            bottom: 0,
            width: '100%',
            borderTop: '1px solid #e8e8e8',
            padding: '10px 16px',
            textAlign: 'right',
            left: 0,
            background: '#fff',
            borderRadius: '0 0 4px 4px',
          }"
        >
          <a-button style="margin-right: 8px" @click="resetForm('ruleForm')">取消</a-button>
          <a-button type="primary" @click="submitForm('ruleForm')">保存</a-button>
        </div>
      </a-drawer>

      <a-drawer
        :visible="viewVisible"
        :title="title"
        destroyOnClose
        @close="closeView()"
        :maskClosable="false"
        width="960rpx"
      >
        <a-descriptions bordered>
          <a-descriptions-item label="灯光名">{{ ruleForm.title }}</a-descriptions-item>
          <a-descriptions-item label="灯光类型">{{ ruleForm.lightType }}</a-descriptions-item>
          <a-descriptions-item label="色温范围">{{ ruleForm.temperatureMin }}K ~ {{ ruleForm.temperatureMax }}K</a-descriptions-item>
          <a-descriptions-item label="供电方式">{{ ruleForm.powerSupplyMode }}</a-descriptions-item>
          <a-descriptions-item label="连接方式">{{ ruleForm.connectionMode }}</a-descriptions-item>
          <a-descriptions-item label="购买链接">{{ ruleForm.purchaseLink }}</a-descriptions-item>
          <a-descriptions-item label="图片"><img :src="ruleForm.pic" width="100" /></a-descriptions-item>
          <a-descriptions-item label="语言">{{ ruleForm.lang }}</a-descriptions-item>
          <a-descriptions-item label="排序字段">{{ ruleForm.idx }}</a-descriptions-item>
        </a-descriptions>

          <div class="addStep"><p class="step">设备连接指引步骤：</p><a-button  class="btn_add" @click="openAddView(ruleForm.id,ruleForm.steps?.length || 0)"><img width="20px" src="../../../static/images/plus.png" /></a-button></div>
          <a-collapse>
            <a-collapse-panel :key="index" v-for="(item,index) in ruleForm.steps" :header="index + 1 + '. ' + item.title">
              <a-button  class="btn_add" @click="openAddDetailView(item)"><img width="20px" src="../../../static/images/plus.png" /></a-button>
              <p  :key="idx" v-for="(step,idx) in item.details">{{ idx + 1 + '. ' + step.detail }} <a-button  class="btn_del" @click="deleteDetail(step.id)"><img src="../../../static/images/delete.png" /></a-button></p>
              <template #extra> <a-button  class="btn_del" @click="deleteStep(item.id)"><img   src="../../../static/images/delete.png" /></a-button></template>
            </a-collapse-panel>
          </a-collapse>
      </a-drawer>

      <a-modal
        :visible="addVisiable"
        :title="title"
        destroyOnClose
        @ok="addStep()"
        @cancel="closeView('addVisiable')"
        :maskClosable="false"
        width="1000px"
      >
        <a-form-model
          ref="ruleForm"
          class="Firmware-version_ruleForm"
          :model="addStepForm"
          :rules="addStepRules"
        >
          <a-form-model-item label="步骤名：">
            <a-textarea  placeholder="请输入步骤名" v-model="addStepForm.title"   :maxlength="1024" />
          </a-form-model-item>
        </a-form-model>
      </a-modal>

      <a-modal
        :visible="addDetailVisiable"
        :title="title"
        destroyOnClose
        @ok="addStepDetail()"
        @cancel="closeView('addDetailVisiable')"
        :maskClosable="false"
        width="1000px"
      >
        <a-form-model
          ref="ruleForm"
          class="Firmware-version_ruleForm"
          :model="addStepDetailForm"
        >
          <a-form-model-item label="步骤详情：">
            <a-textarea  placeholder="请输入步骤详情" v-model="addStepDetailForm.detail"   :maxlength="1024" />
          </a-form-model-item>
        </a-form-model>
      </a-modal>
    </div>
  </template>
  
  <script>
  import pageTitle from "@/components/business/pageTitle";
  import businessGroup from "@/components/business/businessGroup";
  import formTime from "@/components/business/Form/formTime";
  import formSkeleton from "@/components/business/Form/formSkeleton";
  import { confirm, tips } from "@/utils/util";
  import moment from "moment";
  import { multipartUpload } from "@/utils/Oss";
  import { formatToStr } from "@/utils/dateUtils";
  export default {
    components: {
      pageTitle,
      businessGroup,
      formTime,
      formSkeleton
    },
    name: "Firmware-version",
    created() {
    },
    data() {
      let validatePass = (rule, value, callback) => {
        if (value === "" || value === undefined) {
          callback(new Error("不能为空"));
        } else {
          callback();
        }
      };
  
      let checkInput = (rule, value, callback) => {
          const regex = /[A-Za-z0-9]+/;
          if (value === "" || value === undefined) {
            callback(new Error("不能为空"));
          }else if(!regex.test(value)){
            callback(new Error("不能只包含特殊字符"));
          } else {
            callback();
          }
        };
  
      return {
        labelCol: { span: 8 },
        wrapperCol: { span: 14 },
        langs:[{value:"cn",label:"中文"},{value:"de",label:"德语"},{value:"en",label:"英语"},{value:"fr",label:"法语"},{value:"es",label:"西语"},{value:"it",label:"意语"},{value:"ja",label:"日语"},{value:"nl",label:"荷兰语"}],
        upLoading: false,
        files: [],
        dateFormat: this.$root.$data.dateFormat,
        nowTitleIsNew: false, //当前弹窗类型
        fileName: "",
        title: undefined,
        viewVisible:false,
        addVisiable:false,
        addDetailVisiable:false,
        pT: {
          pageTitle: "设备添加指引"
        },
        tableConfig: {
          url: "/bluetoothlight/web/nccManageLight/instruction/query",
          columns: [
            {
              title: "图片",
              key: "pic",
              align: "center",
              scopedSlots: { customRender: "pic" },
            },
            {
              title: "灯光名",
              dataIndex: "title",
              key: "title",
              align: "center"
            },
            {
              title: "灯光类型",
              key: "lightType",
              dataIndex:'lightType',
              align: "center"
            },
            {
              title: "语言",
              key: "lang",
              align: "center",
              scopedSlots: { customRender: "lang" },
            },
            {
              title: "操作",
              align: "center",
              width: 150,
              scopedSlots: { customRender: "action" },
            }
          ],
          rowKey: "id",
        },
        addStepForm:{},
        addStepDetailForm:{},
        formConfig: {
          timeShow: false,
          formShow: true,
        },
        pageLoading: false,
        loading: false,
        visible: false,
        ruleForm: {
          // packageSize 默认为禁用 文件上传成功之后回显
        },
        rules: {},
        addStepRules:{},
        refresh: false,
        upUserList: [],
        
      };
    },
    methods: {
      moment,
      dataFormatStr(ret,format){
        if(!ret){
            return "";
        }
        if(!format){
            format = "YYYY-MM-DD HH:mm:ss";
        }
        return formatToStr(ret,format)
      },
      add() {
        this.title = "新增";
        this.visible = true;
        this.nowTitleIsNew = true;
      },
      details: async function (id) {
        if (this.loading) return false;
        this.loading = true;
        const res = await this.$get(`bluetoothlight/web/nccManageLight/instruction/detail?id=${id}`);
        this.loading = false;
        return res?.resultData || {};
      },
      view: async function (id) {
        const data = await this.details(id);
        this.ruleForm = { ...data };
        this.title = "详情";
        this.viewVisible = true;
      },
      // 编辑  deviceModel 转了 number
      edit: async function (record) {
        this.nowTitleIsNew = false;
        const data = await this.details(record?.id);
        // 回显更新包链接
        this.files = [
          {
            uid: data.id || "-1",
            name: data.title || "更新包",
            status: "done",
            url: data.pic,
          },
        ];
        this.ruleForm = { ...data};
        this.title = "编辑";
        this.visible = true;
      },
      // 删除  关键词  rowKey
      del(record) {
        const id = record?.id;
        if (!id || this.pageLoading) return false;
  
        this.pageLoading = true;
  
        const payload = {
          okBack: async () => {
            const res = await this.$http(
              "DELETE",
              `bluetoothlight//web/nccManageLight/instruction/del/${id}`
            );
            const resultStatus = res?.resultStatus;
            if (resultStatus) {
              tips(this, true);
              this.refreshData();
            }
          },
          title: `是否删除该步骤`,
        };
        confirm(this, payload);
        this.pageLoading = false;
      },
      // 验证表单和提交数据
      submitForm(formName) {
        if (!formName) return false;
        this.$refs[formName].validate(async (valid) => {
          if (!valid) return false;
  
          let releaseDate = this.ruleForm?.releaseDate;
          if (releaseDate) {
            releaseDate = this.dataFormatStr(releaseDate,'YYYY-MM-DD');
          }
  
          let res;
          if(this.nowTitleIsNew){
            res = await this.$post(
                `bluetoothlight/web/nccManageLight/instruction/add`,
                {
                ...this.ruleForm
                }
            );
          }else{
            res = await this.$post(
                `bluetoothlight/web/nccManageLight/instruction/edit`,
                {
                ...this.ruleForm
                }
            );
          }
           
          const resultStatus = res?.resultStatus;
          if (resultStatus) {
            tips(this, true);
            this.visible = false;
            this.refreshData();
            this.resetForm("ruleForm");
          }
        });
      },
      // 重置表单和隐藏 modal
      resetForm(formName) {
        this.$refs[formName].resetFields();
        this.visible = false;
        this.ruleForm = {};
        this.files = [];
        if (this.upLoading) {
          this.upLoading = false;
        }
      },
      // 刷新table数据
      refreshData() {
        this.$refs?.["businessGroup"]?.getData?.();
      },
  
      cancel(cancel) {
        return cancel;
      },
      UploadClient: async function (file) {
        this.fileName = "" + (file?.name || file?.uid)?.replace(".xlsx", "");
        this.upLoading = true;
        const res = await multipartUpload(this.fileName, file, this.cancel,"ncc");
        const resultStatus = res?.resultStatus;
        if (!resultStatus) {
          this.upLoading = false;
          tips(this, resultStatus, res.name === "cancel" ? "上传已取消" : "上传失败");
          return false;
        }
        // const res = await multipartUpload(this.fileName, file, this.cancel);
        if (!this.visible) return false; // 上传开始之后, 关闭了弹窗则阻止数据更新。应该是 取消 client的上传
        this.files = [{ ...res, uid: file?.uid }];
  
        // 计算md5
        const sliceLength = 10;
        const chunkSize = Math.ceil(file.size / sliceLength);
        const fileReader = new FileReader();
        let index = 0;
        const loadFile = () => {
          const slice = file.slice(index, index + chunkSize);
          fileReader.readAsBinaryString(slice);
        };
        loadFile();
        fileReader.onload = () => {
          if (index < file.size) {
            index += chunkSize;
            loadFile();
          } else {
          }
        };
  
        this.ruleForm.pic = res?.url;
  
        this.upLoading = false;
      },
      /**
       *  文件上传处理 返回结果时 false, 结束upload的事件
       *  @param {File} file
       *  fileName 获取文件的 name或者id
       *  client 上传到oss 返回  {url,name}
       * */
      beforeUpload(file) {
        this.UploadClient(file);
  
        return false;
      },
      remove() {
        this.ruleForm.pic = undefined;
        this.files = [];
      },
      getTemperature(record){
        return  `${record.temperatureMin} K ~ ${record.temperatureMax} K`;
      },
      closeView(type){
        if(!type){
          this.viewVisible = false;
        }else if(type == 'addVisiable'){
          this.addVisiable = false;
        }else if(type == 'addDetailVisiable'){
          this.addDetailVisiable = false;
        }
      },
      getLangShow(lang){
        let ret = "";
        this.langs.forEach(e => {
          console.log(e);
          if(e.value === lang){
            ret = e.label;
          }
        });
        return ret;
      },
      openAddView(id,length){
        this.addStepForm = {};  
        this.addStepForm.insId = id;   
        this.addStepForm.step = length + 1;           
        this.addVisiable = true;
        this.title='添加步骤';
      },
      openAddDetailView(stepForm){
        this.addStepDetailForm = {};
        this.addStepDetailForm.stepId = stepForm.id;
        this.addStepDetailForm.idx = this.ruleForm.steps ? this.ruleForm.steps.length + 1 : 1;
        this.addDetailVisiable = true;
        this.title='添加步骤详情';
      },
      addStep : async function(){
          let res = await this.$post(
                  `bluetoothlight/web/nccManageLight/instruction/step/add`,
                  {
                  ...this.addStepForm
                  }
              );
          const resultStatus = res?.resultStatus;
          if(resultStatus){
            this.refleshDetail(this.addStepForm.insId);
          }
          this.addVisiable = false;
      },
      addStepDetail : async function(){
          let res = await this.$post(
                  `bluetoothlight/web/nccManageLight/instruction/step/detail/add`,
                  {
                  ...this.addStepDetailForm
                  }
              );
          const resultStatus = res?.resultStatus;
          if(resultStatus){
            this.refleshDetail(this.ruleForm.id);
          }
          this.addDetailVisiable = false;
      },
      refleshDetail : async function(id){
        const data = await this.details(id);
        this.ruleForm = { ...data };
      },
      deleteDetail : async function(id){
        const payload = {
          okBack: async () => {
            let res = await this.$del(
                  `bluetoothlight/web/nccManageLight/instruction/step/detail/del/` + id
              );
            const resultStatus = res?.resultStatus;
            if(resultStatus){
              this.refleshDetail(this.ruleForm.id);
            }
          },
          title: `是否删除该步骤详情`,
        };
        confirm(this, payload);
      },
      deleteStep: async function (stepId){
        const payload = {
          okBack: async () => {
            let res = await this.$del(
                  `bluetoothlight/web/nccManageLight/instruction/step/del/` + stepId
              );
            const resultStatus = res?.resultStatus;
            if(resultStatus){
              this.refleshDetail(this.ruleForm.id);
            }
          },
          title: `是否删除该步骤`,
        };
        confirm(this, payload);
      }
    },
  };
  </script>
  
  <style lang="less">
  .m-upload {
    .ant-upload-select {
      width: 60px;
      height: 60px;
      border: 1px solid #c3c3c3;
      text-align: center;
      line-height: 60px;
    }
  
    .ant-upload-select-picture-card i {
      font-size: 32px;
      color: #999;
    }
  
    .ant-upload-select-picture-card .ant-upload-text {
      margin-top: 8px;
      color: #666;
    }
  }
  
  .Firmware-version_ruleForm {
    width: 840px;
    .ant-form-item-children,
    .ant-calendar-picker {
      width: 100%;
    }
  }

  .addStep{
      display:flex;
      margin: 10px;
  }

 .btn_del {
     border: 0;
  }

  .btn_add {
    border: 0;
  }

  </style>
  